import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import LegacyButton from "legacy/LegacyButton"
import BasicCustomerCard from "legacy/contract-groups-v2/BasicCustomerCard"
import ContractGroupV2PanelPage from "legacy/contract-groups-v2/ContractGroupV2PanelPage"
import { afterSetState, capitalizeFirstLetter } from "legacy/helpers.es6"
import CreateContactBoat from "legacy/manage/CreateContactBoat"
import SearchCustomerForm from "legacy/manage/SearchCustomerForm"
import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"

// Note: $context is loaded globally
// Note: jQuery ($) is loaded globally

class ContractGroupV2AddBoat extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      search: "",
      loadingSearch: false,
      creatingBoat: false,
      updatingBoat: false,
      currentBoatId: "",
    }
    this.handleSelectBoat = this.handleSelectBoat.bind(this)
    this.handleRemoveContact = this.handleRemoveContact.bind(this)
    this.viewContact = this.viewContact.bind(this)
    this.viewBoat = this.viewBoat.bind(this)
    this.cancelEditCreateBoat = this.cancelEditCreateBoat.bind(this)
    this.addBoatCallback = this.addBoatCallback.bind(this)
    this.handleSelectContact = this.handleSelectContact.bind(this)
    this.handleRemoveBoat = this.handleRemoveBoat.bind(this)
  }

  componentDidMount() {
    if ($context.contact) {
      afterSetState(() => {
        this.handleSelectContact($context.contact)
      })
    }
  }

  handleSelectContact(contact) {
    this.props.update({
      selectedContactBoat: null,
      selectedContact: contact,
      tabContactName: contact.name,
    })
    this.setState({ loadingBoats: true })
    $.post(
      $context.contactBoatsUrl,
      { contact_id: contact.id },
      (response) => {
        this.props.update({ contactBoats: response })
        if (response.length === 0) {
          this.selectCreateNewBoat()
          this.props.update({ tabBoatName: "" })
          this.setState({ loadingBoats: false })
        } else if (response.length > 0) {
          if (
            $context.contactBoat &&
            $context.contact &&
            $context.contact.id === contact.id
          ) {
            this.setState(
              { currentBoatId: $context.contactBoat.id, loadingBoats: false },
              () => {
                this.props.update({
                  selectedContactBoat: $context.contactBoat,
                  tabBoatName: $context.contactBoat.name,
                })
              }
            )
          } else {
            this.props.update({
              selectedContactBoat: response[0],
              tabBoatName: response[0].name,
            })
            this.setState({
              currentBoatId: response[0].id,
              loadingBoats: false,
            })
          }
        }
      },
      "json"
    )
  }

  handleRemoveContact() {
    this.props.update({
      selectedContact: null,
      tabContactName: "",
      tabBoatName: "Boat",
      tabTotalPrice: "-",
    })
    this.setState({
      creatingBoat: false,
      updatingBoat: false,
    })
  }

  selectCreateNewBoat() {
    this.setState({
      creatingBoat: true,
      updatingBoat: false,
      currentBoatId: "_create",
      pricing: null,
    })
    this.props.update({
      selectedContactBoat: null,
    })
  }

  handleSelectBoat(e) {
    if (e.target.value === "_create") {
      this.selectCreateNewBoat()
    } else {
      this.setState({
        creatingBoat: false,
        updatingBoat: false,
        currentBoatId: e.target.value,
      })
      const boat = this.props.form.contactBoats.find(
        (boat) => boat.id === parseInt(e.target.value)
      )
      this.props.update({
        selectedContactBoat: boat,
        tabBoatName: boat.name,
      })
    }
  }

  viewContact(contactId) {
    window.open(`${$context.contactUrl}/${contactId}`, "_blank")
  }

  viewBoat(boatId, contactId) {
    window.open(
      `${$context.contactUrl}/${contactId}/contact_boats/${boatId}/edit`,
      "_blank"
    )
  }

  renderBoatInfo(boat) {
    return (
      <div className="grid grid-cols-4 items-center gap-1 p-2">
        <div className="col-span-3 grid grid-cols-3 gap-1">
          <div className="col-span-1">{boat.name}</div>
          <div className="col-span-1">
            LOA: {Math.floor(boat.lengthOverall / 12)}&apos;-
            {boat.lengthOverall % 12}&quot;
          </div>
          <div className="col-span-1">
            Beam: {Math.floor(boat.beam / 12)}&apos;-{boat.beam % 12}&quot;
          </div>
          <div className="col-span-1">
            {capitalizeFirstLetter(boat.boatTypeNew)}
          </div>
          <div className="col-span-1">
            Height: {Math.floor(boat.height / 12)}&apos;-{boat.height % 12}
            &quot;
          </div>
          <div className="col-span-1">
            Draft: {Math.floor(boat.draw / 12)}&apos;-{boat.draw % 12}&quot;
          </div>
        </div>
        <div className="space-x-1">
          <LegacyButton
            onClick={() => this.setState({ updatingBoat: true })}
            type="tertiary"
            className="btn-sm"
          >
            Edit
          </LegacyButton>
          <LegacyButton
            onClick={() => this.handleRemoveBoat()}
            type="tertiary"
            className="btn-sm"
          >
            Remove
          </LegacyButton>
        </div>
      </div>
    )
  }

  handleRemoveBoat() {
    this.props.update({
      selectedContactBoat: null,
      tabBoatName: "Boat",
      tabTotalPrice: "-",
    })
    this.setState({
      currentBoatId: "",
      creatingBoat: false,
      updatingBoat: false,
    })
  }

  renderBoatSelect() {
    if (this.state.loadingBoats) {
      return (
        <div className="mt-4 flex h-40 w-full items-center justify-center bg-gray-100 text-gray-800">
          <span>Loading Boats...</span>
        </div>
      )
    } else {
      return (
        <div>
          <FormGroup
            inputType="select"
            label="Select Boat"
            name="selectedContactBoat"
            value={this.state.currentBoatId}
            onChange={this.handleSelectBoat}
          >
            <option key="default" value="" disabled>
              Select Boat
            </option>
            ,
            <option key="_create" value="_create">
              (New Boat)
            </option>
            {_.uniqBy(this.props.form.contactBoats, (x) => x.id).map((boat) => (
              <option key={boat.id} value={boat.id}>
                {boat.name}
              </option>
            ))}
          </FormGroup>
          {this.state.creatingBoat && (
            <CreateContactBoat
              dataUrl={$context.contactBoatNewUrl.replace(
                "_contact_id_",
                this.props.form.selectedContact.encodedId
              )}
              callback={this.addBoatCallback}
            />
          )}
          {this.props.form.selectedContactBoat != null && (
            <div>
              <div className="grid grid-cols-4 bg-gray-200 p-2">
                <div className="col-span-4 font-semibold">Boat</div>
              </div>
              {!this.state.creatingUpdating &&
                this.renderBoatInfo(this.props.form.selectedContactBoat)}
            </div>
          )}
          {this.state.updatingBoat && (
            <CreateContactBoat
              boat={this.props.form.selectedContactBoat}
              dataUrl={`${$context.contactBoatNewUrl.replace(
                "_contact_id_",
                this.props.form.selectedContact.encodedId
              )}/${this.props.form.selectedContactBoat.encodedId}`}
              callback={this.addBoatCallback}
            />
          )}
        </div>
      )
    }
  }

  renderPricing() {
    if (this.props.loadingPricing) {
      return (
        <div className="mt-4 flex h-40 w-full items-center justify-center bg-gray-100 text-gray-800">
          <span>Loading pricing...</span>
        </div>
      )
    }

    if (this.props.pricingSummaryHtml && this.props.form.selectedContact) {
      return (
        <div>
          <hr />
          <div className="-m-5">
            <div
              dangerouslySetInnerHTML={{
                __html: this.props.pricingSummaryHtml,
              }}
            />
            <div
              dangerouslySetInnerHTML={{
                __html: this.props.billingSummaryHtml,
              }}
            />
          </div>
        </div>
      )
    }
  }

  cancelEditCreateBoat() {
    this.setState({ creatingBoat: false, updatingBoat: false })
  }

  addBoatCallback(contactBoatData) {
    this.props.update({
      contactBoats: this.props.form.contactBoats.concat(contactBoatData),
      selectedContactBoat: contactBoatData,
    })
    this.setState({
      creatingBoat: false,
      updatingBoat: false,
      currentBoatId: contactBoatData.id,
    })
  }

  render() {
    return (
      <ContractGroupV2PanelPage hideNav={true} saving={this.props.saving}>
        <div>
          <div>
            {this.props.form.selectedContact && (
              <div>
                <div className="grid grid-cols-4">
                  <div className="col-span-4 bg-gray-200 p-2 font-semibold">
                    Customer
                  </div>
                </div>
                <div className="mb-2 mt-1 p-2">
                  <BasicCustomerCard
                    customerName={this.props.form.selectedContact.name}
                    email={this.props.form.selectedContact.email}
                    phone={this.props.form.selectedContact.displayPhone}
                  >
                    <LegacyButton
                      onClick={() =>
                        this.viewContact(
                          this.props.form.selectedContact.encodedId
                        )
                      }
                      type="tertiary"
                      className="btn-sm"
                    >
                      View
                    </LegacyButton>
                    <LegacyButton
                      onClick={this.handleRemoveContact}
                      type="tertiary"
                      className="btn-sm"
                    >
                      Remove
                    </LegacyButton>
                  </BasicCustomerCard>
                </div>
                <hr />
                {this.renderBoatSelect()}
              </div>
            )}
          </div>
          {!this.props.form.selectedContact && (
            <SearchCustomerForm
              selectContact={this.handleSelectContact}
              filterContactsPath={$context.filterContactsPath}
              manageContactsPath={$context.manageContactsPath}
              brewerImportPath={$context.brewerImportPath}
              userImportPath={$context.userImportPath}
              isSafeHarborLocation={$context.isSafeHarborLocation}
              isContract={true}
            />
          )}
          {this.renderPricing()}
        </div>
      </ContractGroupV2PanelPage>
    )
  }
}

ContractGroupV2AddBoat.propTypes = {
  form: PropTypes.shape({
    selectedContact: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      email: PropTypes.string,
      displayPhone: PropTypes.string,
      encodedId: PropTypes.string,
    }),
    contactBoats: PropTypes.array,
    selectedContactBoat: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      lengthOverall: PropTypes.number,
      beam: PropTypes.number,
      boatTypeNew: PropTypes.string,
      height: PropTypes.number,
      draw: PropTypes.number,
      encodedId: PropTypes.string,
    }),
  }).isRequired,
  update: PropTypes.func.isRequired,
  saving: PropTypes.bool,
  loadingPricing: PropTypes.bool,
  pricingSummaryHtml: PropTypes.string,
  billingSummaryHtml: PropTypes.string,
}

export default ContractGroupV2AddBoat
